module.exports = __webpack_public_path__ + "assets/images/project/people/baby-chart.png?v=9863dfae";